import React from 'react';
import Configurator from './Configurator';
import Navbar from './Navbar';

const App: React.FC = () => {
  return (
    <div className="App">
      <Navbar />
      <Configurator />
    </div>
  );
};

export default App;
